import {Component, Input} from '@angular/core';
import {EWeatherIcons} from './weather-icons.enum';

/**
 * la-empty
 */
@Component({
  selector: 'la-weather-icon',
  template: `
    <div [ngClass]="{
             'la-icon--x-small': size === 'xsm',
             'la-icon--small': size === 'sm',
             'la-icon--medium': size === 'md',
             'la-icon--large': size === 'large',
             'la-icon--x-large': size === 'xlarge',
             'la-icon--xx-large': size === 'xxlarge',
             'la-icon--card': size === 'card'}" [ngSwitch]="name" class="la-weather-icon">
      <la-clear-sky *ngSwitchCase="WeatherIcons.ClearSky"></la-clear-sky>
      <la-few-clouds *ngSwitchCase="WeatherIcons.FewClouds"></la-few-clouds>
      <la-mist *ngSwitchCase="WeatherIcons.Mist"></la-mist>
      <la-rain *ngSwitchCase="WeatherIcons.Rain"></la-rain>
      <la-scattered-clouds *ngSwitchCase="WeatherIcons.ScatteredClouds"></la-scattered-clouds>
      <la-shower-rain *ngSwitchCase="WeatherIcons.ShowerRain"></la-shower-rain>
      <la-snow *ngSwitchCase="WeatherIcons.Snow"></la-snow>
      <la-thunderstorm *ngSwitchCase="WeatherIcons.Thunderstorm"></la-thunderstorm>
      <!-- Default -->
      <la-mist *ngSwitchDefault></la-mist>
    </div>
  `,
  styles: [`

  `],
})
export class LaWeatherIconComponent {
  public WeatherIcons = EWeatherIcons;
  private _name: string;
  private _size = 'large'; // large is default size of icon

  get size(): string {
    return this._size;
  }

  /**
   * size of various size option of icon: sm
   * md is default size
   */
  @Input()
  set size(name: string) {
    this._size = name.toLowerCase();
  }

  get name(): string {
    return this._name;
  }

  /**
   * name for set icon
   */
  @Input()
  set name(name: string) {
    // Open Weather API icon names support
    switch (name) {
      case '01d':
      case '01n':
        this._name = EWeatherIcons.ClearSky;
        break;
      case '02d':
      case '02n':
        this._name = EWeatherIcons.FewClouds;
        break;
      case '03d':
      case '03n':
        this._name = EWeatherIcons.ScatteredClouds;
        break;
      case '04d':
      case '04n':
        this._name = EWeatherIcons.ScatteredClouds;
        break;
      case '09d':
      case '09n':
        this._name = EWeatherIcons.ShowerRain;
        break;
      case '10d':
      case '10n':
        this._name = EWeatherIcons.Rain;
        break;
      case '11d':
      case '11n':
        this._name = EWeatherIcons.Thunderstorm;
        break;
      case '13d':
      case '13n':
        this._name = EWeatherIcons.Snow;
        break;
      case '50d':
      case '50n':
        this._name = EWeatherIcons.Mist;
        break;
      default:
        this._name = name;
    }
  }
}
